import styled from 'styled-components'

export const MenuItemLabelContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`
